import { InlineRouteErrorPage } from '../../pages/InlineRouteErrorPage';
import { lazyRoute } from './lazyRoute';

/**
 * One element, reused by every mount below — a route element is a descriptor,
 * and at most one of these can be on screen at a time.
 *
 * Without it the nearest `errorElement` is the `auth` group's in `routes.tsx`,
 * and that one replaces an element containing `AppProviders`: a login page that
 * fails to load would take the theme, the translations, the tenant and the
 * Firebase session down with it. Stopping at the page keeps all four.
 */
const errorElement = <InlineRouteErrorPage />;

export const authRoutes = [
  { errorElement, lazy: () => lazyRoute('/Auth/LoginPage'), path: 'login' },
  {
    errorElement,
    lazy: () => lazyRoute('/Auth/ForgotPassword'),
    path: 'forgot-password',
  },
  {
    errorElement,
    lazy: () => lazyRoute('/Auth/RegisterPage'),
    path: 'register',
  },
  {
    errorElement,
    lazy: () => lazyRoute('/Auth/CorpPasswordChangePage'),
    path: 'set-corp-password',
  },
  {
    errorElement,
    lazy: () => lazyRoute('/Auth/AcceptInvitePage'),
    path: 'accept-invite',
  },
  {
    errorElement,
    lazy: () => lazyRoute('/Auth/ResetPasswordPage'),
    path: 'reset-password/:token',
  },
  {
    children: [
      {
        lazy: () =>
          lazyRoute('/OnboardingPages/TrainerOnboarding/TrainerOnboarding'),
        path: 'trainer',
      },
      {
        lazy: () =>
          lazyRoute(
            '/OnboardingPages/OrganizationOnboarding/OrganizationOnboarding',
          ),
        path: 'organization',
      },
      {
        lazy: () =>
          lazyRoute('/OnboardingPages/ClientOnboarding/ClientOnboarding'),
        path: 'client',
      },
      {
        index: true,
        lazy: () =>
          lazyRoute('/OnboardingPages/WelcomeOnboarding/WelcomeOnboarding'),
      },
    ],
    errorElement,
    path: 'onboarding',
  },
];
